var map = {
	"./01_connect.json": "3tXb",
	"./02_data_compress.json": "CVyP",
	"./03_heart_beat.json": "vR2M",
	"./04_subscribe.json": "UYWd",
	"./05_cancel_subscribe.json": "2xEp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EoQc";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/introduce \.json$
// module id = EoQc
// module chunks = 3